export default "__VITE_ASSET__DWTtcT4a__"